<template>
  <div>
    <!-- Searchbar -->
    <wg-modal
      v-if="isAskingToReplace"
      width="400px"
      @closeModal="isAskingToReplace = false"
    >
      <div slot="body" class="wg-row">
        <div
          class="wg-row"
          style="
            margin-bottom: 20px;
            justify-content: center;
            text-align: center;
          "
        >
          <div class="com-anm22-app-text-xxl">
            {{
              $anm22.strLang(
                lang,
                "Do you want to remove the contact?",
                "Si vuole rimuovere il contatto?"
              )
            }}
          </div>
        </div>
        <div class="wg-row" style="justify-content: center; text-align: center">
          <button type="button" @click="resetContact">
            <div>{{ $anm22.strLang(lang, "Yes", "Sì") }}</div>
          </button>
          <button
            type="button"
            class="red"
            style="margin-left: 10px"
            @click="isAskingToReplace = false"
          >
            <div>{{ $anm22.strLang(lang, "No", "No") }}</div>
          </button>
        </div>
      </div>
    </wg-modal>
    <wg-modal width="500px" :maxWidth="'80%'" @closeModal="save">
      <div slot="header" class="no-select" style="font-size: 22px"></div>
      <div slot="body" class="wg-row" style="padding: 0 10px">
        <div
          v-if="order.tableRef"
          class="wg-row no-select table-row"
          style="align-items: center; margin-bottom: 10px"
        >
          <div class="wg-col wg-xs-12 wg-sm-5">
            <div class="wg-row section-title">
              {{ $anm22.strLang(lang, "Table name", "Nome tavolo") }}
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-7">
            <div class="wg-row" style="justify-content: center">
              <input
                type="text" 
                style="font-size: 20px" 
                v-model="tableAlias" 
              />
            </div>
          </div>
        </div>
        <div class="wg-row no-select covers-row" style="align-items: center">
          <div class="wg-col wg-xs-12 wg-sm-5">
            <div class="wg-row section-title">
              {{ $anm22.strLang(lang, "Covers", "Coperti") }}
            </div>
          </div>
          <div class="wg-col wg-xs-12 wg-sm-7">
            <div class="wg-row">
              <div class="controls">
                <div
                  class="display-flex btn minus"
                  @click="setCovers(coversToPay + coversPayed - 1)"
                >
                  <img :src="$anm22.icons.getWorldIcon('remove')" />
                </div>
                <input
                  type="number"
                  style="font-size: 20px; text-align: right"
                  @focus="$event.target.select()"
                  :value="coversToPay + coversPayed"
                  @change="setCovers($event.target.value)"
                />
                <div
                  class="display-flex btn plus"
                  @click="setCovers(coversToPay + coversPayed + 1)"
                >
                  <img :src="$anm22.icons.getWorldIcon('add')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Contact -->
        <div
          class="wg-row no-select contact-form"
          style="align-items: center; margin-bottom: 10px"
        >
          <div
            class="wg-row section-title"
            style="flex-wrap: nowrap; align-items: center; height: 36px"
          >
            {{ $anm22.strLang(lang, "Contact", "Contatto") }}
            <button
              v-if="!hasContact"
              @click="hasContact = true"
              style="margin-left: auto"
            >
              {{ $anm22.strLang(lang, "Add contact", "Aggiungi contatto") }}
            </button>
            <template v-else>
              <img
                v-if="!isSearching"
                class="com-anm22-app-img-fixed-height-m"
                style="margin-left: 10px; cursor: pointer; opacity: 0.6"
                :src="$anm22.icons.getWorldIcon('deleteBin')"
                @click="isAskingToReplace = true"
              />
              <img
                v-if="!isSearching"
                class="com-anm22-app-img-fixed-height-m"
                style="margin-left: auto; cursor: pointer; opacity: 0.6"
                :src="$anm22.icons.getWorldIcon('searchLeft')"
                @click="isSearching = true"
              />
              <template v-else>
                <div style="margin-left: auto">
                  <wg-search
                    :placeholder="
                      $anm22.strLang(
                        lang,
                        'Type to search...',
                        'Digita per cercare...'
                      )
                    "
                    :url="'contact/get-hints'"
                    :clickFn="selectContact"
                    :debounceTime="2000"
                  >
                    <template v-slot:default="{ result }">
                      <div class="wg-row">
                        <div class="wg-row" style="font-size: 16px">
                          {{ result["firstName"] + " " + result["lastName"] }}
                        </div>
                        <div
                          class="wg-row"
                          style="font-size: 14px; color: #666"
                        >
                          {{
                            (result["email"] || "") +
                            " " +
                            (result["phone"] || "")
                          }}
                        </div>
                      </div>
                    </template>
                  </wg-search>
                </div>
                <img
                  class="com-anm22-app-img-fixed-height-m"
                  style="margin-left: 10px; cursor: pointer; opacity: 0.6"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  @click="isSearching = false"
                />
              </template>
            </template>
          </div>
          <form v-if="hasContact" @submit.prevent="saveContact">
            <div class="wg-row contact-form">
              <div class="wg-row">
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "First name", "Nome") }}
                    </div>
                    <input type="text" v-model="contactEdit.firstName" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "Last name", "Cognome") }}
                    </div>
                    <input type="text" v-model="contactEdit.lastName" />
                  </div>
                </div>
              </div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "Email", "Email") }}
                    </div>
                    <input type="text" v-model="contactEdit.email" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "Phone", "Telefono") }}
                    </div>
                    <div class="wg-row sub-row">
                      <select
                        class="com-anm22-app-select"
                        v-model="contactEdit.phoneAreaCode"
                        style="width: 70px"
                      >
                        <option
                          v-for="(
                            ac, index
                          ) in $anm22.tableClasses.areaCode().getAll()"
                          :key="'ac-' + index"
                          :value="ac.typeClassLiteral"
                        >
                          {{ ac[lang] }}
                        </option>
                      </select>
                      <input
                        style="margin-left: 2px"
                        type="number"
                        v-model="contactEdit.phoneNumber"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "Company", "Azienda") }}
                    </div>
                    <input type="text" v-model="contactEdit.company" />
                  </div>
                </div>
              </div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "Address", "Indirizzo") }}
                    </div>
                    <div class="wg-row sub-row">
                      <input type="text" v-model="placeEdit.addressStreet" />
                      <input
                        type="text"
                        style="width: 60px; margin-left: 2px"
                        placeholder="N."
                        v-model="placeEdit.addressNumber"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "City", "Città") }}
                    </div>
                    <input type="text" v-model="placeEdit.addressCity" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "ZIP code", "CAP") }}
                    </div>
                    <input type="text" v-model="placeEdit.addressZip" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "State", "Provincia") }}
                    </div>
                    <input type="text" v-model="placeEdit.addressState" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "Country", "Nazione") }}
                    </div>
                    <select
                      class="com-anm22-app-select"
                      v-model="placeEdit.addressCountry"
                    >
                      <option
                        v-for="(
                          c, index
                        ) in $anm22.tableClasses.worldCountry().getAll()"
                        :key="'country-' + index"
                        :value="c.typeClassLiteral"
                      >
                        {{ c[lang] }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="wg-row">
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{
                        $anm22.strLang(lang, "Lottery code", "Codice lotteria")
                      }}
                    </div>
                    <input type="text" v-model="contactEdit.lotteryCode" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "Tax code", "Codice fiscale") }}
                    </div>
                    <input type="text" v-model="contactEdit.taxCode" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "VAT number", "P.IVA") }}
                    </div>
                    <input type="text" v-model="contactEdit.vatCode" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "PEC", "PEC") }}
                    </div>
                    <input type="text" v-model="contactEdit.pec" />
                  </div>
                </div>
                <div class="wg-col wg-xs-12 wg-sm-6">
                  <div class="wg-row input-container">
                    <div class="label">
                      {{ $anm22.strLang(lang, "SDI", "SDI") }}
                    </div>
                    <input type="text" v-model="contactEdit.sdi" />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="vertical-height-div" style="height: 10px"></div>
        <div class="wg-row no-select" style="justify-content: center">
          <button type="button" @click="save">
            <div>{{ $anm22.strLang(lang, "Confirm", "Conferma") }}</div>
          </button>
          <!-- <button type="button" class="red" style="margin-left: 10px">
          <div>{{ $anm22.strLang(lang, "Cancel", "Annulla") }}</div>
        </button> -->
        </div>
      </div>
    </wg-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import ImportCSV from "../inventory/ImportCSV.vue";

export default {
  components: { ImportCSV },
  props: {
    order: Object,
    contact: Object,
  },
  data() {
    return {
      error: "",
      coversToPay: this.order.covers[0].filter((c) => !c).length,
      coversPayed: this.order.covers[0].filter((c) => c).length,
      tableAlias: this.order.tableAlias,
      hasContact: false,
      isSearching: false,
      isAskingToReplace: false,
      contactEdit: {},
      placeEdit: {},
      hints: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
    }),
  },
  methods: {
    setCovers(num) {
      if (num < 0) {
        num = 0;
      }
      if (num < this.coversPayed) {
        this.coversToPay = 0;
        this.error = this.$anm22.strLang(
          this.lang,
          "Cannot remove covers that have already been paid",
          "Impossibile rimuovere coperti già pagati"
        );
      } else {
        this.error = "";
        this.coversToPay = num - this.coversPayed;
      }
    },
    save() {
      const covers = Array(this.coversToPay)
        .fill(0)
        .concat(this.order.covers[0].filter((c) => c));
      const contactToSave = this.contactEdit;
      if (contactToSave.places.length > 0) {
        contactToSave.places[0].place = this.placeEdit;
      } else {
        contactToSave.places.push({
          place: this.placeEdit,
          isMain: true,
        });
      }
      this.$emit("cover-modal-update", {
        covers: covers,
        tableAlias: this.tableAlias,
        contact: this.hasContact ? contactToSave : null,
      });
    },
    async selectContact(contactId) {
      const response = await this.$http.get("contact/get-contact", {
        params: {
          contactId,
        },
      });
      // Update contactEdit and placeEdit with new contact data
      if (response.data.error) {
        return; // Stampa errore
      }
      this.contactEdit = { ...response.data.contact };
      this.hasContact = true;
      if (
        response.data.contact.places &&
        response.data.contact.places.length > 0
      ) {
        this.placeEdit = { ...response.data.contact.places[0].place };
      }
      // Emit contact selected
      this.$emit("select-contact", response.data.contact);
    },
    resetContact() {
      this.contactEdit = {
        firstName: "",
        lastName: "",
        email: "",
        phoneAreaCode: "+39",
        phoneNumber: "",
        company: "",
        vatCode: "",
        taxCode: "",
        pec: "",
        sdi: "",
        places: [],
      };
      this.placeEdit = {
        addressStreet: "",
        addressNumber: "",
        addressZip: "",
        addressCity: "",
        addressState: "",
        addressCountry: "it",
      };
      this.isAskingToReplace = false;
      this.hasContact = false;
      this.$emit("reset-contact");
    },
  },
  created() {
    if (this.contact) {
      this.contactEdit = { ...this.contact };
      this.hasContact = true;
    } else {
      this.contactEdit = {
        firstName: "",
        lastName: "",
        email: "",
        phoneAreaCode: "+39",
        phoneNumber: "",
        company: "",
        vatCode: "",
        taxCode: "",
        pec: "",
        sdi: "",
        places: [],
      };
    }
    if (this.contact && this.contact.places && this.contact.places.length > 0) {
      this.placeEdit = { ...this.contact.places[0].place };
    } else {
      this.placeEdit = {
        addressStreet: "",
        addressNumber: "",
        addressZip: "",
        addressCity: "",
        addressState: "",
        addressCountry: "it",
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  font-size: 20px;
  margin-bottom: 10px;
}
.covers-row,
.table-row {
  margin-bottom: 10px;
  .controls {
    display: grid;
    width: 100%;
    grid-template: 36px / 1fr 1fr 1fr;
    column-gap: 5px;
    margin-bottom: 10px;
    .btn {
      justify-content: center;
      align-items: center;
      flex-wrap: nowrap;
      width: 100%;
      height: 100%;
      font-size: 20px;
      border-radius: 5px;
      border: 1px solid #ccc;
      cursor: pointer;
      .minus {
      }
      .plus {
      }
    }
    input {
      width: 100%;
    }
  }
}
.contact-form {
  width: 100%;
  .icon-button {
    height: 100%;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
  }
  .input-container {
    padding: 2px 5px;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: flex-start;
    .sub-row {
      flex-wrap: nowrap;
    }
    .label {
      flex-wrap: nowrap;
      align-items: center;
      font-size: 14px;
      img {
        height: 12px;
        width: 12px;
        margin-left: 10px;
        cursor: pointer;
      }
    }
    input,
    select {
      max-width: 100%;
      width: 100%;
      margin-top: 2px;
    }
  }
}
</style>
